import LineMetricMerger from "@/classes/lineMetricMerge/LineMetricMerger";

export default class DecompositionLineMerger extends LineMetricMerger {
  protected get mergeKey(): string {
    return this.settings?.decompositionMetric ?? "";
  }
}
